import {
  SET_CURRENT_USER,
  SET_USER_PERMISSIONS,
  LOGIN_AS_USER,
  SET_LOGIN_AS,
  SET_WORKSCREEN,
  SET_ACCOUNTING_TYPE,
  SET_CAR_RENTALSYSTEM_TYPE,
  SET_HAS_PARTNER,
  SET_COMPANY_HAVE_ASSIGNED_ESG,
  // SET_ALLOWCARRENTALOVERVIEW,
  SET_DEPARTMENT_TYPE,
  SET_ALLOW_CHANGE_DELIVERY,
  SET_ORDERLIST_USE_TIME_PICUP,
  SET_SHOP_ACTIVE_PUNCHCLOCK,
  SET_PREV_WORKSCREEN,
  SET_ALLOW_NO_CUSTOMER,
  SET_NEW_ORDERS_GROUPING
} from '../constants'

const initialState = {
  isAuthenticated: false,
  user: {},
  permissions: {},
  inactiveUsers: [],
  myscreen: {
    UserId: 0,
    Active: false,
    Step1: false,
    Step2: false,
    Step3: false,
    Step4: false,
    Step5: false,
    Step6: false,
    Step7: false
  },
  accountingSystem: 0,
  carRentalSystem: 0,
  hasPartner: false,
  departmentType: 0,
  customerAllowChangeDelivery: false,
  shopUseTimeForPickupOnOrderList: true,
  prevWorkscreen: null,
  allowNoCustomer: false,
  newOrdersGrouping: 0,
  companyHaveAssignedESG: false
}

export default (state = initialState, action = {}) => {
  switch (action.type) {
    case SET_ACCOUNTING_TYPE:
      return {
        ...state,
        accountingSystem: action.accountingSystem
      }
    case SET_CAR_RENTALSYSTEM_TYPE:
      return {
        ...state,
        carRentalSystem: action.carRentalSystem
      }
    case SET_HAS_PARTNER:
      return {
        ...state,
        hasPartner: action.hasPartner,
        partnerName: action.partnerName,
        partnerForsiBodyShopId: action.partnerForsiBodyShopId
      }
    case SET_DEPARTMENT_TYPE:
      return {
        ...state,
        departmentType: action.departmentType
      }
    // case SET_ALLOWCARRENTALOVERVIEW:
    //   return {
    //     ...state,
    //     allowCarRentalOverview: action.allowCarRentalOverview
    //   }
    case SET_ALLOW_CHANGE_DELIVERY:
      return {
        ...state,
        customerAllowChangeDelivery: action.customerAllowChangeDelivery
      }
    case SET_ALLOW_NO_CUSTOMER:
      return {
        ...state,
        allowNoCustomer: action.payload
      }
    case SET_ORDERLIST_USE_TIME_PICUP:
      return {
        ...state,
        shopUseTimeForPickupOnOrderList: action.shopUseTimeForPickupOnOrderList
      }
    case SET_SHOP_ACTIVE_PUNCHCLOCK:
      return {
        ...state,
        shopPunchClockActive: action.shopPunchClockActive
      }
    case SET_NEW_ORDERS_GROUPING:
      return {
        ...state,
        newOrdersGrouping: action.grouping
      }
    case SET_CURRENT_USER:
      return {
        ...state,
        isAuthenticated: !(Object.keys(action.user).length === 0),
        user: action.user
      }
    case SET_USER_PERMISSIONS:
      return {
        ...state,
        permissions: action.permissions
      }
    case SET_WORKSCREEN:
      return {
        ...state,
        myscreen: action.myscreen
      }
    case SET_PREV_WORKSCREEN:
      // console.log('[reducers/auth] SET_PREV_WORKSCREEN', action)
      return {
        ...state,
        prevWorkscreen: action.prevWorkscreen
      }
    case LOGIN_AS_USER:
      let inactiveUsers = [...state.inactiveUsers]
      let user = null
      if (action.user === null) {
        user = action.newUser
        inactiveUsers = inactiveUsers.slice(0, inactiveUsers.findIndex(x => x.UserId === user.UserId && x.UserType === user.UserType))
        // console.log('login as user, action user is null', user)
      } else {
        if (typeof action.companyId !== 'string') {
          let oldUser = { ...state.user }
          let ws = parseInt(window.localStorage.getItem('workscreen_view'))
          if (ws > -1) oldUser.PrevWorkscreenView = ws
          inactiveUsers.push(oldUser)
          // console.log('[reducers/auth] set inactive OldUser', oldUser)
        }
        user = action.user
        // console.log('login as user', user)
      }
      // if (user.myscreen === undefined || user.myscreen.Active) {
      //   window.localStorage.setItem('workscreen_view', null)
      // }
      console.log('[reducers/auth] login as user', user)
      window.localStorage.setItem('inactiveUsers', JSON.stringify(inactiveUsers))
      window.localStorage.setItem('loginAsUser', JSON.stringify(user))
      return {
        ...state,
        inactiveUsers: inactiveUsers,
        user: user
      }
    case SET_LOGIN_AS:
      return {
        ...state,
        inactiveUsers: action.inactiveUsers,
        user: action.user
      }
    case SET_COMPANY_HAVE_ASSIGNED_ESG:
      return {
        ...state,
        companyHaveAssignedESG: action.companyHaveAssignedESG
      }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/app/reducers/auth.js